import React, { useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import styled from "styled-components";
import {
  CloudUpload,
  LeftArrowBlack,
  RightArrowWhite,
  RightArrowWithoutBar,
} from "../../../../components/styled/AllImages";
import {
  BackButton,
  Box,
  ButtonStyled,
  HeadingStyled,
  LabelStyled,
  SpanStyled,
} from "../../../../components/styled/Elements";
import { useTranslation } from "react-i18next";
import ValidatedInput from "../../../../components/common/inputFields/ValidatedInput";
import { Controller, useForm } from "react-hook-form";
import Breadcrumbs from "../../../../components/admin/Breadcrumbs/Breadcrumbs";
import { useNavigate, useParams } from "react-router-dom";
import MultiFileUploader from "../../../../components/common/inputFields/fileUploader/MultifileUploader";
import { LazyLoadDropdown } from "../../../../components/common/inputFields/LazyLoadDropdown";
import { formatAmountForDisplay } from "../../../../utils";
import ProductsApi from "../../../../services/api/productsApi";
import { toast } from "react-toastify";

const AddProduct = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const typeOptions = [
    { value: 1, label: t("product") },
    { value: 2, label: t("service") },
  ];
  const {
    register,
    control,
    watch,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [loading, setLoading] = useState(false);

  const onSubmit = async (dataObj) => {
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("action", "create");
      Object.entries(dataObj).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          value.forEach((val, index) => formData.append(`${key}[]`, val));
        } else formData.append(key, value);
      });
      const { code, message } = await ProductsApi.createProduct(id, formData);
      if (code === 200) {
        toast.success(message);
        dispatchEvent(new Event("productUpdated"))
        navigate(`/products-categories/${id}/products`);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Box className="content-head">
        <Box className="d-flex align-items-center flex-wrap flex-sm-nowrap gap-3 gap-md-5">
          <BackButton
            label={t("add_product")}
            onClick={() => navigate(`/products-categories/${id}/products`)}
          />
          <Breadcrumbs />
        </Box>
      </Box>
      <Box className="content-container">
        <FormWrapper>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Row>
              <Col md={6}>
                <ValidatedInput
                  weight="600"
                  column={true}
                  start={true}
                  name="name_en"
                  type="input"
                  fieldType="text"
                  placeholder="e.g. Smart Home Hub"
                  label="name_en"
                  className="combined px-0"
                  // staric="staric"
                  register={register}
                  errors={errors}
                  validationRules={{
                    required: true,
                  }}
                />
              </Col>
              <Col md={6}>
                <ValidatedInput
                  weight="600"
                  column={true}
                  start={true}
                  name="name_ar"
                  type="input"
                  fieldType="text"
                  placeholder="مثال: مركز المنزل الذكي"
                  label="name_ar"
                  className="combined px-0"
                  // staric="staric"
                  register={register}
                  errors={errors}
                  validationRules={{
                    required: true,
                  }}
                />
              </Col>
            </Row>
            <LazyLoadDropdown
              weight="600"
              label="product_type"
              // weight="600"
              name="product_type"
              control={control}
              placeholder={t("select_product_type")}
              options={typeOptions}
              value={watch("product_type")}
              register={register}
              errors={errors}
              validationRules={{ required: true }}
            />

            <Row>
              <Col md={6}>
                <Controller
                  name="price"
                  control={control}
                  rules={{ required: true }}
                  render={({
                    field: { onChange, value, ref },
                    fieldState: { error },
                  }) => (
                    <ValidatedInput
                      weight="600"
                      column={true}
                      start={true}
                      name="price"
                      type="input"
                      fieldType="number"
                      placeholder="e.g. SAR 50"
                      label="price"
                      className="combined px-0"
                      // staric="staric"
                      register={register}
                      errors={errors}
                      validationRules={{
                        required: true,
                      }}
                      // value={value ? formatAmountForDisplay(value) : ""}
                      value={value}
                      onChange={(e) => {
                        onChange(e.target.value);
                        // const inputValue = e.target.value;
                        // const raw = inputValue.replace(/,/g, "");
                        // if (
                        //   raw === "" ||
                        //   raw === "." ||
                        //   /^\d*\.?\d{0,2}$/.test(raw)
                        // ) {
                        //   onChange(raw);
                        // }
                      }}
                    />
                  )}
                />
              </Col>
              <Col md={6}>
                <ValidatedInput
                  weight="600"
                  column={true}
                  start={true}
                  name="unit_of_measurement"
                  type="input"
                  fieldType="text"
                  placeholder="e.g. Per hour / Per incident"
                  label="unit_of_measurement"
                  className="combined px-0"
                  // staric="staric"
                  register={register}
                  errors={errors}
                  validationRules={{
                    required: true,
                  }}
                />
              </Col>
            </Row>

            <Box className="mb-4">
              <ValidatedInput
                weight="600"
                name="description"
                column={true}
                start={true}
                type="textarea"
                fieldType="text"
                placeholder="write_description"
                label="description"
                className="combined px-0"
                // staric="staric"
                register={register}
                errors={errors}
                validationRules={{
                  required: true,
                }}
              />
            </Box>

            <HeadingStyled size="20px" color="var(--text)" className="mb-3">
              {t("Attachments")}
            </HeadingStyled>

            <Box className="mb-4">
              <MultiFileUploader
                weight="600"
                name="images"
                control={control}
                rules={{ required: false }}
                label={"image"}
                acceptType="image"
                maxFiles={6}
              />
            </Box>
            <Box className="mb-4">
              <MultiFileUploader
                weight="600"
                name="videos"
                control={control}
                rules={{ required: false }}
                label={"video"}
                acceptType="video"
                maxFiles={6}
              />
            </Box>
            <Row className="mb-4">
              <Col md={6} sm={12}>
                <MultiFileUploader
                  weight="600"
                  width="100% !important"
                  name="catalog"
                  control={control}
                  rules={{ required: false }}
                  label={"catalog"}
                  acceptType="application/pdf"
                  maxFiles={1}
                />
              </Col>
              <Col md={6} sm={12}>
                <MultiFileUploader
                  weight="600"
                  width="100% !important"
                  name="others"
                  control={control}
                  rules={{ required: false }}
                  label={"others"}
                  acceptType="*"
                  maxFiles={1}
                />
              </Col>
            </Row>

            <FooterButtons>
              <ButtonStyled
                border="var(--borderExtraLight)"
                iconBefore={LeftArrowBlack}
                bg="transparent"
                label={t("Cancel")}
                color="var(--text)"
                type="button"
                onClick={() => navigate(-1)}
              />
              <ButtonStyled
                icon={RightArrowWhite}
                type="submit"
                label={t("create")}
                isLoading={loading}
                disabled={loading}
                bg="var(--themeColor)"
              />
            </FooterButtons>
          </Form>
        </FormWrapper>
      </Box>
    </>
  );
};

export default AddProduct;

const FormWrapper = styled.div`
  padding: 30px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
`;

const UploadGrid = styled.div`
  margin-bottom: 20px;
`;

const UploadBox = styled.div`
  background: #f7f9fd;
  border: 2px dashed #d9e2ec;
  border-radius: 12px;
  padding: 30px;
  text-align: center;
  color: #6c757d;
  font-size: 14px;
  margin-bottom: 20px;

  span {
    color: #000;
    font-weight: 600;
  }

  small {
    display: block;
    margin-top: 8px;
    font-size: 12px;
    color: #a0a0a0;
  }
`;

const FooterButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 15px;
  margin-top: 30px;
`;
